<div [ngSwitch]="type">
  <form-history-scf
    *ngSwitchCase="formType.SCF"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  ></form-history-scf>
  <form-history-rsswa
    *ngSwitchCase="formType.RSSWA"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  ></form-history-rsswa>
  <!-- EB history renders the selected snapshot directly instead of using the live original body. -->
  <form-history-eb
    *ngSwitchCase="formType.EBF"
    [originalBody]="update?.currentBody ?? originalBody"
    [update]="update"
    [status]="status"
  >
  </form-history-eb>
  <!-- PPSTB history must render the selected amendment snapshot, including canceled amendments. -->
  <ppstb-main-s1
    *ngSwitchCase="formType.PPSTB"
    [form]="update?.currentBody ?? originalBody"
    [showAmendment]="status?.isViewingAmendment ?? false"
    [disabled]="true"
    [isLogView]="true"
  ></ppstb-main-s1>
  <form-history-rsf
    *ngSwitchCase="formType.RSF"
    [originalBody]="originalBody ?? update.currentBody"
    [update]="update"
    [status]="status"
  ></form-history-rsf>
</div>
